import { render, staticRenderFns } from "./ReserveTransfersList.vue?vue&type=template&id=20d27e2b&"
import script from "./ReserveTransfersList.vue?vue&type=script&lang=js&"
export * from "./ReserveTransfersList.vue?vue&type=script&lang=js&"
import style0 from "./ReserveTransfersList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports